import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import styles from './styles/homeHero.module.css';
import bgimage from '../../../../src/assets/images/bgimage.png';
import googleplayicon from '../../../../src/assets/images/google-play.png';
import appleicon from '../../../../src/assets/images/apple_icon.png';
import mobilemockup from '../../../../src/assets/images/mockup.png';
import { Link } from "react-router-dom";

export default function HomeHero() {
  const [isMobile, setIsMobile] = useState(false);

  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 390); 
    };

    checkScreenSize(); // Check initial screen size
    window.addEventListener('resize', checkScreenSize); 

    AOS.init({
      duration: 1000, 
      once: true, 
    });

    return () => window.removeEventListener('resize', checkScreenSize); // Clean up on unmount
  }, []);

  return (
    <div className={`${styles.heroContainer} relative w-11/12 mx-auto bg-gradient-to-b from-purple-600 via-purple-500 to-purple-400 py-16 sm:py-28 rounded-lg`}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={bgimage}
          alt="Dance Revolution Background"
          className="object-cover w-full h-full rounded-lg"
        />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 sm:py-20 md:py-28 flex flex-col items-center text-center">
        {/* Title */}
        <h1 data-aos="fade-up" className={`${styles.heroTitle} text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight`}>
          Unleash your moves, Join the dance revolution
        </h1>

        {/* Subtitle */}
        <p data-aos="fade-up" data-aos-delay="200" className={`${styles.heroSubtitle} text-white text-sm sm:text-base md:text-lg lg:text-xl mt-4 max-w-lg sm:max-w-xl md:max-w-2xl`}>
          Discover, compete and connect with Nigeria’s premier dance competition. Elevate your dance journey.
        </p>

        {/* Buttons */}
        <div data-aos="fade-up" className={`${styles.heroButtonContainer} mt-8 flex flex-col sm:flex-row space-y-1 sm:space-y-0 sm:space-x-4`}>
          <Link target="_blank" to="https://play.google.com/store/apps/details?id=com.techwings.beatsfussion"
            className={`${styles.heroButton} px-8 sm:px-10 py-3 text-white rounded-lg flex items-center justify-center space-x-2 hover:bg-purple-900`}
            style={{ backgroundColor: '#fa18e2' }}
          >
            <img src={googleplayicon} alt="Google Play" className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-sm sm:text-base text-left font-medium">
              Get it on <br /> <span className="text-lg">Google Play</span>
            </span>
          </Link>
          <Link 
            target="_blank" 
            to="https://apps.apple.com/app/beats-fussion/id6748238785"
            className={`${styles.heroButton} px-6 sm:px-8 py-3 bg-purple-800 text-white rounded-lg flex items-center justify-center space-x-2 hover:bg-purple-900`}
          >
            <img src={appleicon} alt="App Store" className="w-8 h-8 sm:w-10 sm:h-10" />
            <span className="text-sm sm:text-base text-left font-medium">
              Download on the <br /> <span className="text-lg">App Store</span>
            </span>
          </Link>
        </div>
      </div>

      {/* Mockup Image Positioned Partially Into Background */}
      {!isMobile && (
        <div className={`${styles.mobileMockup} hidden sm:block absolute left-1/2 transform -translate-x-1/2 -translate-y-2 sm:-translate-y-14 md:-translate-y-16 lg:-translate-y-20 z-20`}>
          <img
            src={mobilemockup}
            alt="Mobile Mockup"
            className="w-60 sm:w-72 md:w-80 lg:w-96"
          />
        </div>
      )}
    </div>
  );
}
